import React from 'react'
import ExperienceSearchPageFilters from './ExperienceSearchPageFilters'
import TextButton from 'components/Luxkit/Button/TextButton'
import FilterPanelFilterGroup from 'components/Common/FilterPanel/FilterPanelFilterGroup'
import ExperiencesSortByOptions from './ExperiencesSortByOptions'
import ModalBase from 'components/Luxkit/Modal/ModalBase'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalContent from 'components/Luxkit/Modal/ModalContent'
import ModalFooter from 'components/Luxkit/Modal/ModalFooter'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'

interface Props {
  open?: boolean;
  showSortOptions?: boolean;
  onClose?: () => void;
  placeId: string;
}

function ExperienceSearchPageFiltersSidebar(props: Props) {
  const {
    open,
    onClose,
    placeId,
    showSortOptions,
  } = props

  const title = showSortOptions && 'Sort & filter' || 'Filter'

  return (
    <ModalBase
      mode="drawer"
      isOpen={open}
      onClose={onClose}
      >
      <ModalHeader
        title={title}
        onCloseButtonClick={onClose}
      />
      <ModalBody>
        <ModalContent>
          {showSortOptions &&
            <FilterPanelFilterGroup title="Sort by">
              <ExperiencesSortByOptions />
            </FilterPanelFilterGroup>
            }
          <ExperienceSearchPageFilters
            placeId={placeId}
          />
        </ModalContent>
      </ModalBody>
      <ModalFooter>
        <TextButton kind="primary" onClick={onClose} fit="full-width">
          Apply
        </TextButton>
      </ModalFooter>
    </ModalBase>
  )
}

export default ExperienceSearchPageFiltersSidebar
